import { useEffect, useState } from "react";
import { BasePageContainer } from "../../../../components/common";
import CustomLoader from "../../../../components/common/CustomLoader";
import { Outlet } from "react-router-dom";

const ImpartAI = () => {

  const [loading, setLoading] = useState(false);

  useEffect(() => {
  }, []);

  const renderImpartAI = () => {
    return <Outlet></Outlet>
  }

  return (
    <div className="row mx-0 loginwrap">
      <BasePageContainer>
        {loading && <CustomLoader full />}
        {renderImpartAI()}
      </BasePageContainer>
    </div>
  );
};

export default ImpartAI;
